export enum CompanyRole {
  Operational = 1,
  Reader = 2,
}
